import ArticleModal from './article-modal';

export default ArticleModal;
